import ResponsibleLayout from '~/components/Responsible/Layout';

export const route = {
  info: {
    login: false,
  },
} satisfies RouteDefinition;

export default ResponsibleLayout;
